import classNames from 'classnames'
import { StaticIcon } from 'components/common/StaticIcon'
import { useIsMobile } from 'hooks'
import useTranslation from 'next-translate/useTranslation'
import { useEffect, useRef, useState } from 'react'
import { isTextClamped } from 'utils/strings'

interface Props {
  description?: string
}

export function ArtistDescription({ description }: Props) {
  const { t } = useTranslation()
  const [hasReadMore, setHasReadMore] = useState(true)
  const [readMore, setReadMore] = useState(true)
  const isMobile = useIsMobile(1024)

  const descriptionRef = useRef<HTMLParagraphElement | null>(null)

  useEffect(() => {
    if (
      descriptionRef.current &&
      descriptionRef.current?.scrollHeight &&
      descriptionRef.current?.clientHeight
    ) {
      setHasReadMore(isTextClamped(descriptionRef.current))
    }
  }, [
    descriptionRef.current?.scrollHeight,
    descriptionRef.current?.clientHeight,
  ])

  if (!description) return null

  let lineClamp = readMore && 'line-clamp-3'

  if (isMobile) lineClamp = readMore && 'line-clamp-5'

  return (
    <>
      <p
        ref={descriptionRef}
        className={`mt-5 whitespace-pre-line text-sm font-normal text-cool-700 sm:mb-4 md:text-base
  ${lineClamp}
`}
      >
        {description}
      </p>

      {hasReadMore && (
        <div>
          <button
            type='button'
            className='inline-flex cursor-pointer items-center text-sm font-normal text-secondary-default'
            onClick={() => setReadMore(!readMore)}
          >
            {readMore ? t('common:read_more') : t('common:read_less')}
            <StaticIcon
              name='chevronDown'
              className={classNames('ml-2', {
                'rotate-180': !readMore,
              })}
            />
          </button>
        </div>
      )}
    </>
  )
}
